// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3sgrx","productName":"Table_productName__30G7b"};